module.exports = __webpack_public_path__ + "img/form-success-modal.07063141.png";